import { useRef, useState } from 'react';
import AssetForm from '../AssetForm/AssetForm';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from '../../../components/LoadingBtn/LoadingBtn';
import api from '../../../api/Api';

function AssetAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const formRef = useRef();

  const handleAdd = (data) => {
    if (loading) return;
    setLoading(true);
    
    api.post(`/api/assets`, data)
      .then(() => {
        toast.success("Asset Added Successfully");
        setTimeout(() => navigate('/assets'), 1000);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to add asset");
      })
      .finally(() => setTimeout(() => setLoading(false), 1000));
  };

  return (
    <>
      {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}
      <div className='d-flex align-items-center mx-3'>
        <div style={{ width: "200px" }}><Link to="/assets" className="btn btn-secondary mt-3 mb-3">← Back</Link></div>
        <div className="flex-grow-1 text-center"><h3 className='mt-3'>Add Asset</h3></div>
        <div style={{ width: "200px", textAlign: "right" }}>
          <LoadingBtn
            type="submit"
            text="Submit"
            loading={loading}
            disabled={loading}
            onClick={() => {
              if (!loading) {
                formRef.current.submitForm();
              }
            }}
          />  
        </div>
      </div>
      <div className="container" style={{ width: "900px", height: '450px', overflowY: 'auto' }}>
        <AssetForm ref={formRef} onSubmit={handleAdd} />
      </div>
    </>
  );
}

export default AssetAdd;